<template>

  <div class="products">   
    <div class="container">
     
        
        <div class="row">
         <!-- Categorias -->
        <div class="col-md-3 order-md-1 mb-4">
          <product-filter 
          :key="filter_key"
          :categories="categories" 
          :subcategories="subcategories" 
          :cate="cate_filter" 
          :subcate="subcate_filter" 
          :caliber="caliber_filter" 
          :brand="brand_filter" 
          :crit="crit_filter"
          :query="query_filter"
          :titulo_interno="internal_name_es" 
          :brands="brands" 
          :calibers="calibers" />       
        </div>
        <div class="col-md-9 order-md-2">
          <div v-if="query_filter!=0" style="text-align: left;">
            <strong>Mostrando resultados de la búsqueda para: "{{query_filter}}"</strong>
            <br>
            <br>
          </div>
         <!-- {{  "criterio: " + crit_filter + " página: " + page_filter + " categoría: " + cate_filter + " subcategoría: " + subcate_filter + " calibre: " + caliber_filter + " marca: " + brand_filter + " query: " + query_filter }} -->

          <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
          <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
           
          <template v-if="products_list.length == 0">
          </template>
          <template v-else>
          <div class="row" v-if="show_paginado">
            
              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{current_page}} de {{final_page}}</small>
                </div>
                  <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm">
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item">
                          <router-link :to="'/productos/'+crit_filter+'/1/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></router-link></li>
                      </template>
                      <template v-if="current_page > 1">
                        <li role="none presentation" class="page-item" aria-hidden="true">
                          <router-link :to="'/productos/'+crit_filter+'/'+(current_page-1)+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' ">
                            <span class="page-link page-selector" aria-hidden="true">‹</span>
                          </router-link>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                      </template>
                      <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page == current_page) ? 'active' : '']">
                        <router-link :to="'/productos/'+crit_filter+'/'+page+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</router-link></li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" aria-hidden="true">
                          <router-link :to="'/productos/'+crit_filter+'/'+(parseInt(current_page)+1)+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter  + (query_filter == 0 ? '' : '/'+query_filter)+'' ">
                            <span class="page-link page-selector" aria-hidden="true">›</span>
                          </router-link>
                        </li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item">
                          <router-link :to="'/productos/'+crit_filter+'/'+final_page+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link">
                            <span class="page-selector" aria-hidden="true">»</span>
                          </router-link></li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>

            <div class="col-md-12">
               <!-- <h4 class="mb-3">Billing address</h4> -->
              <card-loader :loopCount=12 v-if="loading"/>
              <products-list :products_list="products_list" />
            </div>

              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{current_page}} de {{final_page}}</small>
                </div>
                  <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm">
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item">
                          <router-link :to="'/productos/'+crit_filter+'/1/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></router-link></li>
                      </template>
                      <template v-if="current_page > 1">
                        <li role="none presentation" class="page-item" aria-hidden="true">
                          <router-link :to="'/productos/'+crit_filter+'/'+(current_page-1)+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' ">
                            <span class="page-link page-selector" aria-hidden="true">‹</span>
                          </router-link>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                      </template>
                      <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page == current_page) ? 'active' : '']">
                        <router-link :to="'/productos/'+crit_filter+'/'+page+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</router-link></li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" aria-hidden="true">
                          <router-link :to="'/productos/'+crit_filter+'/'+(parseInt(current_page)+1)+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter  + (query_filter == 0 ? '' : '/'+query_filter)+'' ">
                            <span class="page-link page-selector" aria-hidden="true">›</span>
                          </router-link>
                        </li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item">
                          <router-link :to="'/productos/'+crit_filter+'/'+final_page+'/'+cate_filter+'/'+subcate_filter+'/'+caliber_filter+'/'+brand_filter + (query_filter == 0 ? '' : '/'+query_filter)+'' " role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link">
                            <span class="page-selector" aria-hidden="true">»</span>
                          </router-link></li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>

          </div>
          </template> 

        </div>
      </div>
    </div>
    <TwoModules></TwoModules>
    <NewModules></NewModules>
  </div>
   
</template>

<script>

import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import ProductsList from "@/components/products/ProductsList";
import CardLoader from "@/components/shared/CardLoader";
import ProductFilter from "@/components/products/filters/ProductFilter"
import axios from "axios";
import _ from "lodash";
import {config_settings} from '../config.js';
import { errorToaster } from '../components/shared/service/ErrorHandler';

  //HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(
    function (response) { return response; }, 
    function(error) {
      
        if(error.message === 'Network Error'){
          toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                          "ERROR",
                          {"iconClass": 'customer-danger'});
        }
        else if(error.response.status === UNAUTHORIZED){
          if(error.response.data.message === "Access is denied"){
            toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                          "ERROR",
                          {"iconClass": 'customer-danger'});
          }
          else {
            return Promise.reject(error);
          }
        }
        else {
          return Promise.reject(error);
        }
    }
  );

export default {
  name: "allProducts",
  components: { ProductsList, CardLoader, ProductFilter, TwoModules, NewModules },
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      cod_sub_sec: 8,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      categories: [],
      subcategories: [],
      calibers: [],
      brands: [],
      products_list: [],
     
      loading: false,
      pages: [],
      
      current_page: 1,
      final_page: 1,
      perPage: 12, 
      filter_key: 1,
      

      //subcategoria: this.$route.params.subcate,
      //categoria: this.$route.params.cate,

      crit_filter: this.$route.params.crit,
      page_filter: this.$route.params.page,
      cate_filter: this.$route.params.cate,
      subcate_filter: this.$route.params.subcate,
      caliber_filter: this.$route.params.caliber,
      brand_filter: this.$route.params.brand,
      query_filter: this.$route.params.query,

      mensaje: '',
      mensaje_error: '',

      show_paginado: false
    }
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },

  methods: {
    
    ocultar(){
       this.mensaje = ""
       this.mensaje_error = ""
    },
    
    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 

               //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
              
          })
           .catch(error => {
           
      })
    },

    scroll_inicio() {
      window.scrollTo(0,0);
    },

    listar_categorias(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/categories')
            .then(response => {
              this.categories = response.data;
            })
            .catch(error => {
             
            })
    },

    listar_subcategorias(valor_categoria){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/categories/'+ valor_categoria + '/subcategories')
           .then(response => {
              this.subcategories = response.data.subcategories;
           })
           .catch(error => {
             
           })
    },

    listar_calibres(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/calibers/only_enabled')
            .then(response => {
              this.calibers = response.data;
            })
            .catch(error => {
             
            })
    },

    listar_calibresxcate(cate){   
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/category/'+cate+'/calibers/only_enabled')
            .then(response => {
              this.calibers = response.data;
            })
            .catch(error => {
              this.calibers = []
            })
    },

    listar_calibresxsubcate(subcate){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/subcategory/'+subcate+'/calibers/only_enabled')
            .then(response => {
              this.calibers = response.data;
            })
            .catch(error => {
              this.calibers = []
            })
    },

    listar_marcas(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/brands/only_enabled')
            .then(response => {
              this.brands = response.data;
            })
            .catch(error => {
             
            })
    },

    listar_marcasxcate(cate){
      this.brands = [];
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/category/'+cate+'/brands/only_enabled')
            .then(response => {
              this.brands = response.data;
            })
            .catch(error => {
             
            })
    },

    listar_marcasxsubcate(subcate){
      this.brands = [];
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/subcategory/'+subcate+'/brands/only_enabled')
            .then(response => {
              this.brands = response.data;
            })
            .catch(error => {
             
            })
    },

    listar_productos(){

      //búsqueda
      typeof this.query_filter === 'undefined' ? this.query_filter = 0 : this.query_filter;

      typeof this.cate_filter === 'undefined' ? this.cate_filter = 0 : this.cate_filter;
      typeof this.subcate_filter === 'undefined' ? this.subcate_filter = 0 : this.subcate_filter;
      typeof this.crit_filter === 'undefined' || this.crit_filter == 'undefined' ? this.crit_filter = 0 : this.crit_filter;
      typeof this.page_filter === 'undefined' ? this.page_filter = 1 : this.page_filter;
      typeof this.caliber_filter === 'undefined' ? this.caliber_filter = 0 : this.caliber_filter;
      typeof this.brand_filter === 'undefined' ? this.brand_filter = 0 : this.brand_filter;

      let url = "";

      if(this.query_filter==0){

        if(!(this.cate_filter !=0 && this.subcate_filter == 0)) {
          if(this.caliber_filter==0 && this.brand_filter==0){
            url = "/GET/catalog/products?xPag="+this.perPage+"&&cat="+this.subcate_filter+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter;
          }
          else {
            url = "/GET/catalog/products-2?xPag="+this.perPage+"&&cat="+this.subcate_filter+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter+"&&caliber="+ (this.caliber_filter == 0? "disabled" : this.caliber_filter) +"&&brand="+ (this.brand_filter == 0? "disabled" : this.brand_filter);
          }
        }
        else {
          if(this.caliber_filter==0 && this.brand_filter==0){
            url = "/GET/catalog/productsxcategory?xPag="+this.perPage+"&&cat="+this.cate_filter+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter;
          }
          else {
            url = "/GET/catalog/products-2xcategory?xPag="+this.perPage+"&&cat="+this.cate_filter+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter+"&&caliber="+ (this.caliber_filter == 0? "disabled" : this.caliber_filter) +"&&brand="+ (this.brand_filter == 0? "disabled" : this.brand_filter);
          }
        }

        this.servicio_productos(url);

      }
      else {

        let data_json = {};
        if(!(this.cate_filter !=0 && this.subcate_filter == 0)) {
          url = "/POST/catalog/products/search_paginate?xPag="+this.perPage+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter;
          data_json = {
            "query": this.query_filter,
            "subcate" : this.subcate_filter
          }
        }
        else {
          url = "/POST/catalog/search_productsxcategory?xPag="+this.perPage+"&&cat="+this.cate_filter+"&&crit="+this.crit_filter+'&&nPag='+this.page_filter;
          data_json = {
            "query": this.query_filter,
          }
        }

        this.buscar_productos(url,data_json);
        
      }

      

    },

    servicio_productos(url){
      axios.get(config_settings.RESOURCE_SERVER_URL+url)
                .then(response => {
                  var arreglo = response.data.products
                   if(arreglo.length==0) {
                    this.mensaje_error = "Ocurrió un error, no existen resultados para el filtro solicitado"
                   }
                  this.loading = false;
                  this.products_list = response.data.products;
                  this.pages = response.data.visible_pages
                  this.final_page = response.data.final_page
                  this.current_page = this.page_filter
                  this.mensaje_error = ""
                  this.mensaje = ""
                  this.show_paginado = true;
                  //this.scroll_inicio();
                })
                .catch(error => {
                  this.loading = false;
                  this.show_paginado = false;
                  if (error.response.status === NOT_FOUND){
                      this.mensaje_error = "Ocurrió un error, inténtelo nuevamente"
                  }  
                  else {
                      toastr.error(error.response.data.details,
                            error.response.data.message,
                            {"iconClass": 'customer-danger'});
                            this.mensaje_error = "Ocurrió un error, no existen resultados para el filtro solicitado.";
                            this.mensaje = "";
                  }  
                })
    },

    buscar_productos(url,data_json){
      axios({
          method: 'POST',
          url: config_settings.RESOURCE_SERVER_URL+url,
          data: data_json,
        })
                .then(response => {
                  var arreglo = response.data.products
                   if(arreglo.length==0) {
                    this.mensaje_error = "Ocurrió un error, no existen resultados para el filtro solicitado"
                   }
                  this.loading = false;
                  this.products_list = response.data.products;
                  this.pages = response.data.visible_pages
                  this.final_page = response.data.final_page
                  this.current_page = this.page_filter
                  this.mensaje_error = ""
                  this.mensaje = ""
                  this.show_paginado = true;
                  this.scroll_inicio();
                })
                .catch(error => {
                  this.loading = false;
                  this.show_paginado = false;
                  if (error.response.status === NOT_FOUND){
                      this.mensaje_error = "Ocurrió un error, no existen resultados para la búsqueda solicitada."
                  }  
                  else {
                      toastr.error(error.response.data.details,
                            error.response.data.message,
                            {"iconClass": 'customer-danger'});
                            this.mensaje_error = "Ocurrió un error, no existen resultados para el filtro solicitado.";
                            this.mensaje = "";
                  }  
                })
    },

    detalleSubCategoria(valor_subcategoria){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/categories/subcategories/'+ valor_subcategoria)
           .then(response => {
              this.detail_subcate = response.data;
              //SEO
              this.page_title = response.data.product_type_desc_es;
              this.page_description = response.data.detail_category_es;
              this.page_keywords = response.data.keywords;
           })
           .catch(error => {
             
           })
    },

    detalleCategoria(valor_categoria){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/categories/'+ valor_categoria)
           .then(response => {
              this.detail_cate = response.data;
              //SEO
              this.page_title = response.data.product_type_desc_es;
              this.page_description = response.data.detail_category_es;
              this.page_keywords = response.data.keywords;
           })
           .catch(error => {
             
           })
    },

    detalleCategoriaPadre(valor_categoria_padre){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/categories_father/'+ valor_categoria_padre)
           .then(response => {
              this.detail_cate = response.data;
              //SEO
              this.page_title = response.data.product_type_desc_es;
              this.page_description = response.data.detail_category_es;
              this.page_keywords = response.data.keywords;
           })
           .catch(error => {
             
           })
    },

  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.listar_productos();
    this.listar_categorias();
    this.listar_calibres();
    this.listar_marcas();
  },

  watch: {
    '$route': function (route) {

      //SEO
      this.page_title = this.nom_sub_sec_es;
      this.page_description = "Catálogo de productos de Armaq Pesca";

      this.crit_filter=route.params.crit;
      this.page_filter=route.params.page;
      this.cate_filter=route.params.cate;
      this.subcate_filter=route.params.subcate;
      this.caliber_filter=route.params.caliber;
      this.brand_filter=route.params.brand;
      this.query_filter=route.params.query;
      
      this.filter_key = this.filter_key + 1;
      //this.obtener_sub_section_data();
      this.listar_productos();
 
    }
  }
}
</script>

<style lang="scss">
.products {
  @media(min-width:992px) {
     padding-top: 130px;
  }
}

.form-control {
  border-radius: 0px !important;
  font-size: 13.5px;
}


</style>

